import React, { useState } from 'react'
import moment from 'moment'

import { DOSEME_SITE_URL } from '../../constants/urls/frontend'
import { version } from '../../../package.json'

import './index.scss'

const FooterC: React.FC = () => {
  const currentYear = moment().year()
  const footerLogo =
    '<svg width="100%" height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><g><path d="M42.721,22.976c-1.176,0 -2.155,-0.815 -2.42,-1.908c-1.447,-0.237 -3.122,-0.18 -4.597,0.742c-2.097,1.156 -4.596,4.574 -7.473,8.582l0.108,0.584c1.308,7.056 3.284,9.777 4.293,9.883c0.509,0.088 1.342,-0.649 2.232,-2.782c2.63,-6.305 7.496,-13.006 11.334,-13.006l1.574,0c-1.08,-1.023 -2.293,-1.903 -3.568,-2.593c-0.416,0.308 -0.925,0.498 -1.483,0.498Z" style="fill:#7c7c7c;fill-rule:nonzero;"/><path d="M21.221,34.111c0.781,0.134 1.686,-0.45 2.682,-1.729c0.626,-0.858 1.238,-1.711 1.836,-2.546l-2.682,-14.468c-1.282,-6.914 -3.077,-8.533 -3.66,-8.574c-0.448,0.012 -1.633,0.861 -2.836,4.465c-0.674,2.02 -1.766,5.043 -3.033,8.464c0.807,1.479 1.542,3.273 2.175,5.36c0.481,1.421 0.944,2.619 1.384,3.634c1.329,0.056 2.391,1.142 2.391,2.482c0,0.457 -0.132,0.88 -0.347,1.248c0.9,1.208 1.618,1.584 2.09,1.664Z" style="fill:#7c7c7c;fill-rule:nonzero;"/><path d="M3.271,18.777c1.573,-3.301 3.513,-3.877 4.874,-3.769c1.314,0.098 2.591,0.897 3.772,2.301c1.002,-2.729 1.856,-5.113 2.417,-6.792c1.39,-4.165 3.131,-6.208 5.226,-6.063c3.233,0.225 4.941,5.828 5.806,10.488l2.274,12.262c2.562,-3.519 4.733,-6.237 6.874,-7.414c1.764,-1.106 3.958,-1.437 6.379,-0.993c0.455,-0.494 1.103,-0.807 1.828,-0.807c1.334,0 2.414,1.048 2.482,2.363c1.702,0.901 3.286,2.102 4.656,3.493c-0.644,-13.195 -11.528,-23.703 -24.899,-23.703c-13.785,0 -24.96,11.16 -24.96,24.928c0,0.173 0.022,0.34 0.026,0.512l3.245,-6.806Z" style="fill:#7c7c7c;fill-rule:nonzero;"/><path d="M46.198,27.416c-1.814,0 -6.178,4.4 -9.167,11.563c-1.554,3.726 -3.383,4.348 -4.647,4.213c-3.267,-0.347 -5.105,-5.968 -6.031,-10.195c-0.195,0.269 -0.375,0.522 -0.574,0.795c-1.393,1.791 -2.839,2.685 -4.321,2.685c-0.208,0 -0.418,-0.018 -0.628,-0.054c-1.309,-0.221 -2.53,-1.123 -3.699,-2.746c-0.05,0.003 -0.098,0.015 -0.15,0.015c-1.378,0 -2.496,-1.116 -2.496,-2.493c0,-0.551 0.185,-1.055 0.488,-1.468c-0.506,-1.157 -1.006,-2.459 -1.505,-3.932c-0.342,-1.125 -0.705,-2.126 -1.079,-3.017c-2.379,6.356 -5.094,13.423 -6.84,17.946c4.576,5.652 11.567,9.272 19.411,9.272c12.993,0 23.658,-9.917 24.843,-22.584l-3.605,0Z" style="fill:#7c7c7c;fill-rule:nonzero;"/><path d="M7.969,17.346c-1.199,-0.069 -2.126,1.491 -2.579,2.439l-4.891,10.259c0.616,3.039 1.803,5.866 3.417,8.395c1.939,-5.032 4.724,-12.304 7.025,-18.491c-1.08,-1.699 -2.146,-2.54 -2.972,-2.602Z" style="fill:#7c7c7c;fill-rule:nonzero;"/></g></svg>'
  const [showVersion, setShowVersion] = useState(false)

  const versionNumber = showVersion && <span className='pl-3'>v{version}</span>

  return (
    <div className='doseme-access-footer'>
      <div onClick={() => setShowVersion(true)} className='col-md-1 col-sm-2 col-xs-3 py-2'>
        <div id='footer-logo' dangerouslySetInnerHTML={{ __html: footerLogo }} />
      </div>
      <div className='mt-3 ml-2 col-md-6 col-sm-6 col-xs-6'>
        <small>
          <div className='footer-text mb-1'>Copyright &copy; {currentYear} DoseMe Pty Ltd. All rights reserved.</div>
          <div className='footer-text mb-1'>
            DoseMe ® is a registered trademark of DoseMe Pty Ltd. DoseMeRx℠ and DoseMe℞℠ are service marks of DoseMe
            LLC.
          </div>
          <div className='mb-1'>
            <a className='footer-text' href={`${DOSEME_SITE_URL}/tos/`} target='_blank' rel='noopener noreferrer'>
              Terms of Use
            </a>
            <a
              className='footer-text pl-3'
              href={`${DOSEME_SITE_URL}/privacy/`}
              rel='noopener noreferrer'
              target='_blank'
            >
              Privacy Policy
            </a>
            <a
              className='footer-text pl-3'
              href={`${DOSEME_SITE_URL}/hipaa/`}
              target='_blank'
              rel='noopener noreferrer'
            >
              HIPAA Privacy Statement
            </a>
            <a className='footer-text pl-3' href={`${DOSEME_SITE_URL}/gdpr/`} target='_blank' rel='noopener noreferrer'>
              GDPR Information
            </a>
            {versionNumber}
          </div>
        </small>
      </div>
    </div>
  )
}

export { FooterC as Footer }
